import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'tick-icon',
  templateUrl: './tick-icon.component.html',
  styles: [':host{display: inherit;}']
})
export class TickIconComponent implements OnInit {
  
  @Input() widthHeight: number = 52;
  @Input() bgColor: string = '#fff';
  @Input() tickColor: string = '#49be91';
  @Input() borderColor: string = '#49be91';
  @Input() borderWidth: string = '2px';
  constructor() { }

  ngOnInit(): void {}
}
